import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HeaderComponent } from '../shared/header/header.component';
import { IonAccordion, IonAccordionGroup, IonContent, IonIcon, IonItem, IonLabel, IonList, IonMenu, IonRouterOutlet, MenuController } from '@ionic/angular/standalone';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LangRoutingService } from '../@services/lang-routing';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { Menu } from '../@classes/menu';
import { Tab } from '../@classes/tab';
import { Constants } from '../@classes/constants';

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss'],
  imports: [
    HeaderComponent,
    IonMenu,
    IonContent,
    IonList,
    IonAccordionGroup,
    IonAccordion,
    IonItem,
    IonLabel,
    IonIcon,
    IonRouterOutlet,
    TranslatePipe,
  ],
})
export class MainLayoutComponent  implements OnInit {

  private destroyRef = inject(DestroyRef);
  find_properties: Array<Tab> = Menu.find_properties;
  businesses: Array<Tab> = Menu.businesses;
  info_property: Array<Tab> = Menu.info_property;
  about_uses: Array<Tab> = Menu.about_uses;
  base_url: string = Constants.BASE_URL;

  private langRouting = inject(LangRoutingService);

  constructor(
    private route: ActivatedRoute,
    public translate: TranslateService,
    private menuController: MenuController
  ) { }

  ngOnInit() {
    this.route.paramMap
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(async (params) => {
        const lang = params.get('lang') || 'id';

        this.langRouting.applyLang(lang);
        await this.resetMenuState();
      });
  }

  ionViewDidEnter() {
    this.resetMenuState();
  }

  ionViewWillLeave() {
    this.menuController.close('rebornMenu');
  }

  private async resetMenuState() {
    try {
      const menu = await this.menuController.get('rebornMenu');
      if (menu) {
        menu.disabled = false;
        await menu.close(false);
      }
    } catch (e) {
      console.error('Error resetting menu:', e);
    }
  }

  async navigateTo(url: string) {
    await this.menuController.close('rebornMenu');
    await this.langRouting.navigateByUrl(url);
  }

  async contactUs() {
    await this.menuController.close('rebornMenu');
    await this.langRouting.navigateByUrl('/contactus');
  }

  async switchEn(event?: Event) {
    event?.stopPropagation();
    await this.switchLang('en');
  }

  async switchId(event?: Event) {
    event?.stopPropagation();
    await this.switchLang('id');
  }

  private async switchLang(lang: string) {
    await this.menuController.close('rebornMenu');
    await this.langRouting.switchLang(lang);
  }
}
